import React from "react";
import classes from "./style.module.scss";
import DiscreteSlider from "./RangeSlider";

const SliderView = (props) => {
  const { MaxValue, MinValue, providerDetails } = props;
  return (
    <div className={classes["doctor-compare"]}>
      <div className={classes["peers-compare"]}>
        {providerDetails?.providerValue?.map((item, index) => (
          <div className={classes["peers-value"]} key={item?.key || index}>
            {item.key.includes("Cost") ? (
              <DiscreteSlider maxRange={MaxValue} minRange={MinValue} item={item} />
            ) : (
              <DiscreteSlider maxRange={100} minRange={0} item={item} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SliderView;